import { useState } from "react";
import { toast } from "sonner";
import { Share2, Check } from "lucide-react";

const SHARE_URL = "https://mykitchenbox.com";
const SHARE_TEXT = "Check out KitchenBox — authentic Iraqi & Middle Eastern food in Charlottesville, VA! 🍽️";

export const ShareButton = ({ className = "", label = "Share", testid = "share-button" }) => {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "KitchenBox", text: SHARE_TEXT, url: SHARE_URL });
        return;
      } catch {
        return; // user cancelled
      }
    }
    try {
      await navigator.clipboard.writeText(SHARE_URL);
      setCopied(true);
      toast.success("Link copied! Share it with your friends 🎉");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy the link. Please copy it manually: mykitchenbox.com");
    }
  };

  return (
    <button type="button" onClick={share} data-testid={testid} className={className}>
      {copied ? <Check size={20} /> : <Share2 size={20} />} {copied ? "Copied!" : label}
    </button>
  );
};
